var map = {
	"./decidim/avatar-multiuser.png": 5626,
	"./decidim/brands/google.svg": 7349,
	"./decidim/cc-badge.png": 9156,
	"./decidim/decidim-logo.svg": 3064,
	"./decidim/default-avatar.svg": 704,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 1516,
	"./decidim/icons.svg": 3323,
	"./decidim/pattern.png": 1356,
	"./decidim/placeholder-card-g.svg": 1017,
	"./decidim/placeholder-card-l.svg": 9362,
	"./decidim/placeholder.jpg": 5329,
	"./decidim/remixicon.symbol.svg": 8165,
	"./decidim/vendor/leaflet/layers-2x.png": 6484,
	"./decidim/vendor/leaflet/layers.png": 6595,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 1166,
	"./decidim/vendor/leaflet/marker-icon.png": 3973,
	"./decidim/vendor/leaflet/marker-shadow.png": 3290,
	"./decidim/vendor/social-share-button/douban.svg": 9972,
	"./decidim/vendor/social-share-button/email.svg": 1489,
	"./decidim/vendor/social-share-button/facebook.svg": 247,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 3561,
	"./decidim/vendor/social-share-button/hacker_news.svg": 3569,
	"./decidim/vendor/social-share-button/linkedin.svg": 3681,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 898,
	"./decidim/vendor/social-share-button/pinterest.svg": 3687,
	"./decidim/vendor/social-share-button/reddit.svg": 7227,
	"./decidim/vendor/social-share-button/telegram.svg": 3982,
	"./decidim/vendor/social-share-button/tumblr.svg": 653,
	"./decidim/vendor/social-share-button/twitter.svg": 7280,
	"./decidim/vendor/social-share-button/vkontakte.svg": 5566,
	"./decidim/vendor/social-share-button/wechat.svg": 2953,
	"./decidim/vendor/social-share-button/whatsapp.svg": 9441,
	"./decidim/vendor/social-share-button/x.svg": 1977,
	"./decidim/vendor/social-share-button/xing.svg": 1335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1959;